import React, { useState } from "react";
import DashboardLayout from "app/layout/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/layout/DashboardNavbar";
import Footer from "app/layout/Footer";
import MDBox from "shared/components/MDBox";
import HeaderUser from "./components/HeaderUser";
import TablaUser from "./components/TablaUser";

const Usuario = () => {
  const [refreshFlag, setRefreshFlag] = useState(false);

  const handleUserCreated = () => {
    setRefreshFlag((prev) => !prev);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={2} />
      <HeaderUser onUserCreated={handleUserCreated}>
        {(onCreate) => <TablaUser refreshFlag={refreshFlag} onCreate={onCreate} />}
      </HeaderUser>
      <Footer />
    </DashboardLayout>
  );
};

export default Usuario;
